/**
 * Command Palette Constants
 */

/**
 * Limit of items to show in the command palette per page
 */
export const LIMIT = 10;

/**
 * Footer message helper for determining the current page info and total results
 */
export const getResultsMessage = ({
  count,
  total,
  disabled,
}: {
  count: number;
  total: number;
  disabled: boolean; // isLoading, isFetching or query value < 3
}): string => {
  if (disabled) return "Begin by typing";
  if (count === 0) return "No results";
  if (count === 1) return "Showing 1 result";
  if (total <= LIMIT) return `Showing all ${count} results`;
  return `Showing ${count} of ${total} results`;
};

/**
 * search is enabled helper
 */
export const searchIsEnabled = (searchValue: string): boolean =>
  searchValue.length >= 3;

/**
 * disabled messages
 */
export const DISABLED_MESSAGES = [
  "The amplitudes for these topics are peaking.",
  "We prepared the state with these topics.",
  "Currently in an excited state...",
  "Freshly initialized, for your discovery.",
  "Observe these states of interest.",
  "These topics are a small phase rotation away.",
  "Get entangled with these trending topics.",
];

export const DISABLED_LOGO = "https://assets.cloud.pennylane.ai/command_palette/icons/pennylane-trending-topics-command-palette-flame.png";
